import { useT } from '@repo/ui/hooks'

import { useStoreState } from '@/store/hooks'

export function Description() {
  const { t, tc } = useT({ keyPrefix: 'dashboard.beneficiaryList' })
  const { pagination, loading } = useStoreState((state) => state.beneficiaryList)
  return (
    <>
      {loading
        ? tc('loading', { cfl: true }) + '...'
        : t('description', { count: pagination.totalItems })}
    </>
  )
}
